import React, { Component } from 'react';

class Simulator extends Component {

    

    constructor(props){
        super(props);
        
        const site = 'localhost:7777';

        this.state = {
            themes: [
                {name:'Float','styles':'http://'+site+'/wp-content/themes/church-float/assets/dist/css/site.min.css'},
                {name:'Emphasis','styles':'http://'+site+'/wp-content/themes/church-emphasis/assets/dist/css/site.min.css'},
                {name:'Light & Clean','styles':'http://'+site+'/wp-content/themes/church/assets/css/site.css'},
                {name:'2017','styles':'http://'+site+'/wp-content/themes/2017/assets/dist/css/site.min.css'},
                {name:'Mosaic','styles':'http://'+site+'/wp-content/themes/custom-mosaic/assets/dist/css/site.min.css'},
                {name:'Churchome','styles':'https://churchome.org/css/site.combined.min.15.css'},
                {name:'HTB','styles':'https://static1.squarespace.com/static/sitecss/5a5ca363d0e628da109c4d05/79/55f0aac0e4b0f0a5b7e0b22e/5a5ca363d0e628da109c4d1a/318-05142015/1541003253907/site.css'},
                {name:'Trinity Harlem','styles':'https://static1.squarespace.com/static/sitecss/5490990ce4b01fef27535932/179/52a74dafe4b073a80cd253c5/5490990ce4b01fef27535937/1015-05142015/1541621889297/site.css'},
                {name:'None','styles':null},
            ],
        }
    }

    loadTheme(styles){

        let linkRef = document.getElementById('simulatorStyles');
        linkRef.href = styles;
    }

    themeChange(event){

        // Load Theme
        this.loadTheme(event.target.value);

    }

    renderOptions(){
        return this.state.themes.map((theme,index) => {
            return (<option value={theme.styles} key={index}>{theme.name}</option>)
        })
    }

    componentDidMount(){
        this.loadTheme(this.state.themes[0].styles);
    }

    render() {
        return (
            <div className="Simulator" style={styles.bar}>

                <select onChange={(e) => this.themeChange(e)} style={styles.select}>
                    {this.renderOptions()}
                </select>


            </div>
        );
    }
}

const styles = {

    bar: {
        // backgroundColor: 'black',
        // borderBottom: '1px solid black',
        // textAlign: 'right'
    },
    select: {
        width: '100%',
        backgroundColor: 'blue',
        color: 'white',
        padding: '2em',
        marginBottom: '2em',
        opacity: 0.2,
    }


}

export default Simulator;
